/*
 * The absolute URL a copied permalink carries. The link check every renderer asks first is
 * `routes/safeHref.ts`, which is core's for every module; this is the one address chat composes
 * that is not a path but a whole URL, because it is copied out of the product.
 */

import { messageHref, type Addressable } from "../../../routes/links.ts"

/**
 * The absolute URL a copied permalink carries; the origin is the one the client is served from.
 *
 * The address itself comes from `routes/links.ts`, which knows both kinds of conversation: a
 * channel is `/c/<slug>/p/<seq>` and a direct conversation `/d/<handle>/p/<seq>`. A conversation
 * that carries neither address has no permalink at all, and the caller says so rather than copying
 * a link that leads nowhere.
 */
export function permalinkUrl(conv: Addressable, seq: number): string | null {
	const path = messageHref(conv, seq)
	return path === null ? null : `${globalThis.location.origin}${path}`
}
